import { ValidatorService } from './tools/validator.service';
import { AutenticacionService } from './autenticacion.service';
import { ConstantsService } from './constants.service';
import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
import { ErrorsService } from './tools/errors.service';

@Injectable()
export class LiquidacionCapturaFotografiasService {

  public modulo_url;
  private api_url;
  public service_url;
  constructor(private http: Http, private constantsService: ConstantsService, private authService: AutenticacionService, private validatorService: ValidatorService, private errorService: ErrorsService) {
    this.api_url = this.constantsService.apiURL;
    this.modulo_url = '/liquidacion/captura';
    this.service_url = this.api_url + this.modulo_url;
  }

  getDefaultSchedule(date) {
    return {
      'idLiquidacion_Imagenes': '',
      'idLiquidacion': '',
      'fechas': date,
      'notas': '',
      'imagen': ''
    };
  }

  getFotografias(idLiquidacion, page) {
    if (page) {
      return this.http.get(this.service_url + '/notasImagenes?id=' + idLiquidacion + '&paginate=true&page=' + page, this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '/notasImagenes?id=' + idLiquidacion + '?&paginate=true', this.authService.getAuthHeaders());
  }

  getFotografia(idFotografia) {
    const options = this.authService.getAuthHeaders();
    options.responseType = ResponseContentType.Blob;
    return this.http.get(this.service_url + '/imagen?id=' + idFotografia, options);
  }

  getUpdateURL(){
    return this.service_url + '/imagen/actualizar';
  }

  deleteFotografia(idFotografia) {
    return this.http.delete(this.service_url + '/imagen?id=' + idFotografia, this.authService.getAuthHeaders());
  }

  updateFotografia(data) {
    return this.http.post(this.service_url + '/imagen/actualizar', data, this.authService.getAuthHeaders());
  }

  // buscar objeto simple
  public searchFotografias(idLiquidacion, search, page){
    // buscar con paginacion
    if(page)
      return this.http.get(this.service_url + '/notasImagenes?id=' + idLiquidacion + "&paginate=true&search=" + search + "&page=" + page, this.authService.getAuthHeaders());

    // solo buscar
    return this.http.get(this.service_url + '/notasImagenes?id=' + idLiquidacion + "&paginate=true&search=" + search, this.authService.getAuthHeaders());
  }

  public validateFotografiaDate(date, dateMin, dateMax) {
    if (!this.validatorService.dateBetween(date, dateMin, dateMax)) {
      return this.errorService.betweenDate;
    }
  }

  public validateFotografia(data, localFoto) {
    console.log('validating... ', data);
    let error = [];

    // validacion de fotografia
    if (!this.validatorService.required(localFoto) && !this.validatorService.required(data['idLiquidacion_Imagenes'])) {
      error['fotografia'] = this.errorService.required;
    }


    // validacion de fechas
    if (!this.validatorService.required(data['fechas'])) {
      error['fechas'] = this.errorService.required;
    }

    // validacion de notas
    if (!this.validatorService.required(data['notas'])) {
      error['notas'] = this.errorService.required;
    } else if (!this.validatorService.max(data['notas'], 200)) {
      error['notas'] = this.errorService.max(200);
    }


    return error;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/liquidacion-captura-fotografias.service.ts